<template>
	<component :is="tag" class="text-xl font-bold">
		<slot></slot>
	</component>
</template>

<script lang="ts" setup>
withDefaults(
	defineProps<{
		tag?: string;
	}>(),
	{
		tag: "h6",
	},
);
</script>
